// Field labels per the Confluence "Pricing tool fields" mapping:
// https://aussiecommerce.atlassian.net/wiki/spaces/Extranet/pages/5082742832/Pricing+tool+fields
export const INCLUSION_FIELD_LABELS = {
  currency: 'Currency',
  description: 'Fine print',
  name: 'Inclusion',
  prv: 'PRV',
  rrp: 'RRP',
  type: 'Type',
  validFor: 'Valid for',
} as const;

export const INCLUSION_TYPE_OPTIONS = ['Daily', 'Per Stay'];

export const INCLUSION_VALID_FOR_OPTIONS = ['Adult', 'Teenager', 'Child'] as const;

// Quick-add presets from the mockup - one click prefills name + type.
export const COMMON_INCLUSION_PRESETS: Array<{ label: string; type: 'Per Stay' | 'Daily' }> = [
  { label: 'Daily breakfast', type: 'Daily' },
  { label: 'Airport transfer (return)', type: 'Per Stay' },
  { label: 'Daily dinner', type: 'Daily' },
  { label: 'Spa credit', type: 'Per Stay' },
  { label: 'Daily drinks package', type: 'Daily' },
  { label: 'Welcome amenity', type: 'Per Stay' },
  { label: 'Late checkout', type: 'Per Stay' },
  { label: 'Daily lunch', type: 'Daily' },
  { label: 'Room upgrade', type: 'Per Stay' },
  { label: 'Cocktail hour (daily)', type: 'Daily' },
];
